<template>
  <div class="background">
    <div class="app-sobre">
      <header class="header.">
        <div class="center">
          <div class="logos">
            <div class="logo-ta-na-lei">
              <img
                src="../assets/images/logo_lei_branco.png"
                class="logo-tanalei"
                alt="Logo do Tá na Lei"
                title="Tá na Lei"
              />
              <img
                src="../assets/images/logo_horizontal_branco.png"
                class="logo-tanalei2"
                alt="Logo do Tá na Lei"
                title="Tá na Lei"
              />
            </div>
            <div class="logo-casa-goias">
              <!-- <a href="http://www.casacivil.go.gov.br/">
                <img
                  src="../assets/images/logo-goias-bco.svg"
                  class="imagem-secretaria"
                  alt="Logo da Casa Civil e Governo de Goiás"
                  title="Casa Civil"
                />
              </a> -->
            </div>
          </div>
        </div>
      </header>
      <div class="linha"></div>
      <div class="center">
        <router-link :to="linkVoltar" title="Voltar">
          <img
            src="../assets/images/iconevoltar2.png"
            class="icon-voltar"
            alt="Icone voltar a página inicial"
          />
        </router-link>
        <div class="divisao">
          <div class="direito">

            <div class="baixar">
              <p>
                <strong>Baixe o app:</strong>
              </p>
              <a
                target="_blank"
                href="https://play.google.com/store/apps/details?id=br.gov.go.casacivil.tanalei"
              >
                <img
                  src="../assets/images/logo_android_verde.png"
                  class="logo-android"
                  alt="baixar aplicativo para Android"
                />
              </a>
              <a
                target="_blank"
                href="https://apps.apple.com/br/app/t%C3%A1-na-lei/id1522888504?l=pt-br"
              >
                <img
                  src="../assets/images/logo_apple_verde.png"
                  class="logo-aple"
                  alt="baixar aplicativo para Apple"
                />
              </a>
            </div>

            <div class="row2">
              <img
                src="../assets/images/icon-transparencia.png"
                class="icon-transparecia"
                alt="Icone representando Transparência"
              />
              <p>
                <strong>Transparência</strong>
                Nossas leis em um formato mais
                claro e objetivo, facilitando
                o entendimento de todos.
              </p>
            </div>

            <div class="row2">
              <img
                src="../assets/images/icon-praticidade.png"
                class="icon-praticidade"
                alt="Icone representando Praticidade"
              />
              <p>
                <strong>Praticidade</strong>
                Com o aplicativo, você consulta
                seus direitos onde e quando
                precisar.
              </p>
            </div>

            <div class="row2">
              <img
                src="../assets/images/icon-simplicidade.png"
                class="icon-simplicidade"
                alt="Icone representando a participaação do usuário"
              />
              <p>
                <strong>Simplicidade</strong>
                Os principais trechos de leis em destaque,
                em linguagem fácil e acessível
              </p>
            </div>

            
          </div>
          <div class="text esquerdo">
            <h1>Sobre o Tá na Lei</h1>

            <p>
              Nas últimas décadas, há um movimento cada vez mais forte no Brasil
              para que seja garantido à população o acesso à informação sobre o que
              realmente é o seu direito formal. Cobranças que partem do princípio
              não apenas de defesa do cidadão, mas também do patrimônio público, e
              que colaboram para a propagação de uma mentalidade de correição e de
              maior eficiência de todo o poder público.
            </p>
            <p>
              Desta forma, e considerando o princípio da publicidade que deve reger
              a Administração Pública, a iniciativa do Programa "Tá na Lei" busca
              colocar à disposição dos cidadãos parte do arcabouço legal do nosso
              Estado. E a disponibilização proposta tem a intenção de se dar de
              forma mais simples, com ilustrações e opções para a consulta direta da
              produção legislativa, sobre temas específicos e com comentários sobre
              as leis mais complexas.
            </p>
            <p>
              Nosso objetivo não é somente o de dar publicidade, mas também
              incentivar a inclusão e a participação dos goianos, promovendo as
              condições e os fundamentos para novos programas e projetos de
              participação popular, inclusive com mecanismos de avaliação das
              políticas públicas elaboradas pelo Governo de Goiás. Queremos levar a
              informação não apenas para que você conheça as leis, mas também
              para que nos auxilie na revisão dos nossos atos e das próprias leis,
              provocando um debate social sobre os problemas que vivenciamos no
              nosso Estado. Venha com a gente!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SobreView",
  metaInfo() {
    return {
      title: "Sobre - Tá na Lei",
      titleTemplate: null,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "Sobre o Tá na Lei"
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: "Sobre o Tá na Lei"
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "Sobre - Tá na Lei"
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: `${process.env.VUE_APP_BASE_URL}${this.$route.fullPath}`
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article"
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: process.env.VUE_APP_BASE_URL + "/tanalei_card.jpg"
        },
        {
          vmid: "og:image:secure_url",
          property: "og:image:secure_url",
          content: process.env.VUE_APP_BASE_URL + "/tanalei_card.jpg"
        },
        {
          vmid: "og:image:type",
          property: "og:image:type",
          content: "image/jpeg"
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          property: "twitter:image",
          content: process.env.VUE_APP_BASE_URL + "/tanalei_card.jpg"
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content: "Sobre o Tá na Lei"
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content: `Sobre- Tá na Lei`
        },
        {
          vmid: "twitter:site",
          name: "twitter:site",
          content: `${process.env.VUE_APP_BASE_URL}${this.$route.fullPath}`
        },
        {
          vmid: "twitter:card",
          name: "twitter:card",
          property: "twitter:card",
          content: "summary_large_image"
        },
        {
          vmid: "og:image:width",
          property: "og:image:width",
          content: "1201"
        },
        {
          vmid: "og:image:height",
          property: "og:image:height",
          content: "631"
        }
      ]
    };
  },
  data() {
    return {
      linkVoltar: { name: "IndexLegislacao" }
    };
  }
};
</script>
